<template>
  <section class="app-main">
    <!-- :include="cachedViews" -->
    <keep-alive>
      <router-view />
    </keep-alive>
  </section>
</template>
<script>
export default {
  data() {
    return {};
  },

  computed: {
    cachedViews() {
      return [];
    },
    key() {
      return this.$route.path;
    }
  }
};
</script>
<style lang="scss" scoped>
// .app-main {
//   margin-top: 20px;
//   padding: 10px;
// }
</style>